const SDK_VERSION = '8.19.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
